import { TaskType } from "@remi/enums/task-type";
import { ManualBlockingTaskTypeValues } from "@remi/types/tasks";

import { hasCapability, type User } from "../base";

const EngineerOnlyTaskResetTypes: TaskType[] = [TaskType.NOTICE_TO_PROCEED];

const TaskTypesWithResetDisabled: TaskType[] = [
  TaskType.INSTALL_SCHEDULED,
  TaskType.RECORD_UPSELL_RESULTS,
  ...ManualBlockingTaskTypeValues,
];

export const taskReset = {
  update: (user: User, taskType: TaskType) => {
    if (!hasCapability(user, "taskReset.update")) {
      return false;
    }
    if (TaskTypesWithResetDisabled.includes(taskType)) {
      return false;
    }

    if (EngineerOnlyTaskResetTypes.includes(taskType)) {
      return hasCapability(user, "taskReset.update.engineerOnly");
    }

    return true;
  },
};
